import { lazy } from "react";
import LocalisedLoadingProvider from "components/LocalisedLoadingProvider";
import useCanDo from "hooks/useCanDo";
import { Route } from "react-router-dom";
import { Routes } from "components/Sentry/Routes";
import SettingsMenu from "./SettingsMenu";
import NotFound from "features/NotFound";

const SettingsAccountEdit = lazy(() => import("./SettingsAccountEdit"));
const SettingsAccountArchive = lazy(() => import("./SettingsAccountArchive"));
const SettingsAccountSubscription = lazy(() => import("./SettingsAccountSubscription"));
const SettingsCoachManagement = lazy(() => import("./SettingsCoachManagement"));
const SettingsCoachCreate = lazy(() => import("./SettingsCoachCreate"));
const SettingsCoachEdit = lazy(() => import("./SettingsCoachEdit"));
const SettingsPreferencesEdit = lazy(() => import("./SettingsPreferencesEdit"));
const RAGSettingsV2 = lazy(() => import("./SettingsPreferencesEdit/RAGSettingsV2"));
const SettingsAccountInvite = lazy(() => import("./SettingsAccountInvite"));

const REACT_APP_ENABLE_ATHLETE_INVITE = JSON.parse(process.env.REACT_APP_ENABLE_ATHLETE_INVITE || "false") as boolean;

function Settings() {
  const canDo = useCanDo();

  return (
    <LocalisedLoadingProvider>
      <SettingsMenu>
        <Routes>
          <Route path="/" element={<SettingsAccountEdit />} />
          {canDo("athlete.archive") && <Route path="athlete-archive" element={<SettingsAccountArchive />} />}
          {REACT_APP_ENABLE_ATHLETE_INVITE && canDo("athlete.invite") && (
            <Route path="athlete-invite" element={<SettingsAccountInvite />} />
          )}
          {canDo("subscription.any") && <Route path="subscription" element={<SettingsAccountSubscription />} />}
          {canDo("group.any") && canDo("coach.any") && (
            <>
              <Route path="coaches" element={<SettingsCoachManagement />} />
              <Route path="coaches/create" element={<SettingsCoachCreate />} />
              <Route path="coaches/:coachId/edit" element={<SettingsCoachEdit />} />
            </>
          )}
          <Route path="preferences" element={<SettingsPreferencesEdit />} />
          <Route path="athlete-monitoring" element={<RAGSettingsV2 />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </SettingsMenu>
    </LocalisedLoadingProvider>
  );
}

export default Settings;
